import React from 'react'

const Job = (props) => {
  const { job, team, selectedTeam, nullCheck, description } = props
  // const description = posting.descriptionPlain
  const shortDescription = `${description.trim().substring(0, 250).replace('\n', ' ')}...`
  const locations = nullCheck(job.metadata[2]?.value?.map((location) => location).join(' / '))
  const commitment = nullCheck(job.metadata[0].value)
  const link = job.absolute_url

  return (
    <>
      {(selectedTeam === 'all' || selectedTeam === team) && (
        <div className="job column is-half-tablet is-12-mobile">
          <a className="job-title" href={link} target="_blank" rel="noopener noreferrer">
            {job.title}
          </a>
          <p className="tags">
            <span>{team}</span>
            <span>{locations}</span>
            <span>{commitment}</span>
          </p>
          <p className="description">{shortDescription}</p>
          <a className="btn" href={link} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
        </div>
      )}
    </>
  )
}
export default Job
